<template>
  <div :class="{'layout-padding': page==='prod_reg'}">
    <div :class="{'lp-bg-table' : page==='prod_reg'}">
      <div v-if="page==='prod_reg'" class="lp-bg-sub-header">
        <span class="lp-bg-sub-title">옵션 추가/수정</span>
      </div>
      <div v-if="page==='prod_reg'" class="lp-bg-devision" style="margin: 15px 1%;"></div>

      <!-- 옵션 템플릿 선택 -->
      <div v-if="isTemplate" class="lp-bg-sub-in-group" style="display:flex; align-items:center;">
        <div class="lp-bg-sub-in-title" style="width: 100px;">옵션 템플릿 선택</div>
        <lp-sort-drop-down :ulStyle="{ height: 'auto', maxHeight: '212px', overflowY: 'auto' }" :placeholder="'옵션 템플릿 선택'" @onSelect="selTemplate" :list="templateArr" width="220" bgColor="#fff" borderColor="#ccc" style="display:inline-block; margin-right:8px;"></lp-sort-drop-down>
      </div>

      <!-- 옵션 템플릿 선택 후 -->
      <div v-if="!isTemplate">
        <!-- 옵션 선택 -->
        <div class="lp-bg-sub-in-group" style="display:flex; align-items:center;">
          <div class="lp-bg-sub-in-title" style="display: inline-block; width: 88px; margin:0;">옵션 선택</div>
          <div style="font-size: 0.9rem; color: #666; font-weight: bold;">{{ template }}</div>
        </div>

        <!-- 옵션명 -->
        <div class="lp-bg-sub-in-group">
          <lp-input-text :data.sync="item.name" label="옵션명" labelWidth="80px" inputWidth="60%" block="inline-block"></lp-input-text>
        </div>

        <!-- 옵션 종류 -->
        <div class="lp-bg-sub-in-group" style="display: flex;">
          <div class="lp-bg-sub-in-title" style="display: inline-block; width: 80px;">옵션 종류</div>
          <lp-radio @onSelect="selOptionType" :val.sync="item.type" :data="optionTypeArr" groupMargin="0 0 12px 0" :detailStyle="{ padding: '2px 0 0 4px' }" style="width: 336px;"></lp-radio>
        </div>

        <!-- 상품옵션 기본값 여부 -->
        <div class="lp-bg-sub-in-group" style="display: flex; align-items: center;">
          <div class="lp-bg-sub-in-title" style="display: inline-block; width: 80px;">
            <div>상품옵션</div>
            <div>기본값 여부</div>
          </div>
          <lp-check-bool label="상품등록 시 기본값으로 들어가있는 옵션" :checkedVal.sync="item.isDefault"></lp-check-bool>
        </div>

        <!-- 옵션값 & 옵션가격 -->
        <div v-for="(opt,idx) in item.options" :key="'opt-item'+idx" style="display: flex;">
          <div class="lp-bg-sub-in-group" style="width: 52%">
            <lp-input-text :data.sync="opt.name" label="옵션값" inputWidth="100%" block="block"></lp-input-text>
          </div>
          <div class="lp-bg-sub-in-group" style="width: 36%;">
            <lp-input-text :data.sync="opt.price" label="옵션가격" inputWidth="100%" block="block" fixedText="원" textTop="31px" textRight="-20px"></lp-input-text>
          </div>
          <div style="width: 5%; margin: 40px 0 0 24px; color: #666; cursor:pointer;" @click="deleteOption(idx)">
            <i class="material-icons">close</i>
          </div>
        </div>
        <div style="padding: 10px;">
          <div class="add-opt-value" @click="addOptionValue">옵션값 추가</div>
        </div>

        <div class="lp-bg-devision" style="margin: 15px 0"></div>

        <div v-if="page===undefined" style="display: flex; justify-content: flex-end;">
          <lp-check-bool label="기본 제공 템플릿으로 사용" :checkedVal.sync="item.isOffered"></lp-check-bool>
        </div>

        <div>
          <div v-if="page==='prod_reg' && alreadyExist" class="lp-primary-btn" @click="updateOptPopup">수정하기</div>
          <div v-if="page==='prod_reg' && !alreadyExist" class="lp-primary-btn" @click="newOptPopup">추가하기</div>
        </div>

      </div>

    </div>

  </div>
</template>

<script>
import LpInputText from "../../module/common/LpInputText";
import LpRadio from "../../module/common/LpRadio";
import LpCheckBool from "../../module/common/LpCheckBool";
import LpSortDropDown from "../../module/common/LpSortDropDown";

export default {
  props: ["partner_id", "page", "target", "isTemplate", "alreadyExist"],
  layout: "Main",
  components: {
    LpInputText,
    LpRadio,
    LpCheckBool,
    LpSortDropDown
  },
  data() {
    return {
      item: {},
      template: undefined,
      optionTypeArr: [
        {
          name: "상품속성옵션",
          value: "상품속성옵션",
          detail:
            "*상품 주문 시 반드시 선택해야 하는 상품 속성 성격의 옵션입니다."
        },
        {
          name: "추가옵션",
          value: "추가옵션",
          detail: "*상품 주문 시 추가 주문할 수 있는 성격의 옵션입니다."
        }
      ],
      // 옵션 템플릿 드롭다운 Array
      // * 무조건 마지막 요소는 '새 옵션 추가'여야 함!
      templateArr: [
        { label: "등급", value: "등급" },
        { label: "친환경 여부", value: "친환경 여부" },
        { label: "수확일", value: "수확일" },
        { label: "선물포장", value: "선물포장" },
        { label: "새 옵션 추가", value: "새 옵션 추가" }
      ],
      templateArrOptions: [
        {
          id: 0,
          name: "등급", // 옵션명
          type: "상품속성옵션", // 옵션종류
          isDefault: false, // 기본옵션 (상품옵션 기본값 여부)
          isOffered: false, // 제공됨 (기본 제공 템플릿으로 사용)
          options: [
            // 옵션값, 옵션가격
            { label: "1등급", price: 10000 },
            { label: "2등급", price: 8000 },
            { label: "3등급", price: 6000 }
          ],
          isShow: true
        },
        {
          id: 0,
          name: "친환경 여부", // 옵션명
          type: "상품속성옵션", // 옵션종류
          isDefault: false, // 기본옵션 (상품옵션 기본값 여부)
          isOffered: false, // 제공됨 (기본 제공 템플릿으로 사용)
          options: [
            // 옵션값, 옵션가격
            { label: "무농약, 유기농", price: 5000 },
            { label: "무농약", price: 2000 }
          ],
          isShow: true
        },
        {
          id: 0,
          name: "수확일", // 옵션명
          type: "상품속성옵션", // 옵션종류
          isDefault: false, // 기본옵션 (상품옵션 기본값 여부)
          isOffered: false, // 제공됨 (기본 제공 템플릿으로 사용)
          options: [
            // 옵션값, 옵션가격
            { label: "1개월 이내", price: 4000 },
            { label: "2개월 이내", price: 2000 }
          ],
          isShow: true
        },
        {
          id: 0,
          name: "선물포장", // 옵션명
          type: "상품속성옵션", // 옵션종류
          isDefault: false, // 기본옵션 (상품옵션 기본값 여부)
          isOffered: false, // 제공됨 (기본 제공 템플릿으로 사용)
          options: [
            // 옵션값, 옵션가격
            { label: "리본, 장식추가", price: 2000 },
            { label: "리본", price: 1000 }
          ],
          isShow: true
        }
      ]
    };
  },
  created() {
    if (this.target) {
      this.item = this.target;
      if(this.target.name === '옵션명'){
        this.template = '새 옵션 추가'
      } else {
        this.template = this.target.title;
      }
    }
  },
  watch: {
    target(n) {
      this.item = n;
      if(this.target.name === '옵션명'){
        this.template = '새 옵션 추가'
      } else {
        this.template = n.title;
      }
    },
    item(n) {
      this.$emit('updateOption', n);
    }
  },
  methods: {
    addOptionValue() {
      this.item.options.push({
        name: "",
        price: 0
      });
    },
    selOptionType(val) {},
    selTemplate(val) {
      this.$emit("updateTemplate", false);

      // 저장된 템플릿 정보 가져오기
      if (val !== "새 옵션 추가") {
        let optionIdx = this.templateArr.findIndex(item => item.value === val);
        this.item = this.templateArrOptions[optionIdx];
      } else if (val === "새 옵션 추가") {
        // 새 옵션 추가
        this.item = {
          id: 0,
          name: "옵션명", // 옵션명
          type: "상품속성옵션", // 옵션종류
          isDefault: false, // 기본옵션 (상품옵션 기본값 여부)
          isOffered: false, // 제공됨 (기본 제공 템플릿으로 사용)
          options: [
            // 옵션값, 옵션가격
            { name: "옵션값 입력", price: 0 }
          ],
          isShow: true
        };
      }
    },
    updateOptPopup() {

      /*let url = ''
      if(this.partner_id!==''){
        url = 'partner/'+this.partner_id+'/selector/';
      }
      else{
        url = 'partner/'+this.$store.getters.partner.id+'/selector/';
      }
      this.axios.patch(url, this.item)*/
      //console.log(this.item)
      this.$emit("updateTemplate", true);
      this.$emit("updateOptPopup", this.item);
    },
    newOptPopup() {
      this.$emit("updateTemplate", true);
      this.$emit("newOptPopup", this.item);
    },
    deleteOption(idx) {
      this.item.options.splice(idx, 1);
    }
  }
};
</script>

<style lang="stylus" type="stylus" scoped>
////@import '~assets/css/reset';
//@import '~assets/css/lp_main';

// 상품등록 페이지 모달용 높이
.layout-padding
  max-height 600px
  min-height 320px
  padding 20px

.add-opt-value // 옵션값 추가하기
  display inline-block
  color #555
  background #ddd
  padding 8px 16px
  font-size 0.86rem
  border-radius 3px
  cursor pointer
</style>
